import { type FC, useContext } from 'react';
import { SearchIcon } from 'src/components/shared/elements/icons/SearchIcon';
import { useOverlay } from 'src/hooks/useOverlay';
import { useWindowDimensions } from 'src/hooks/useWindowDimensions';
import { I18nContext } from 'src/stores/I18n';
import { mixpanel } from 'src/utils/mixpanel';
import styles from './index.module.scss';

type Props = {
  showIconOnly?: boolean;
};

export const SearchInput: FC<Props> = ({ showIconOnly }) => {
  const { setIsOverlayVisible } = useOverlay();
  const localeResources = useContext(I18nContext);
  const { width } = useWindowDimensions();

  const handleOnFocus = () => {
    setIsOverlayVisible(true);
    document.body.classList.add('no-scroll');
    mixpanel.onSearchBannerTapped();
  };

  if (showIconOnly) {
    return (
      <div className={styles.searchIconOnly} onClick={handleOnFocus}>
        <SearchIcon width={23} height={23} />
      </div>
    );
  }

  return (
    <fieldset className={styles.searchContainer} onClick={handleOnFocus}>
      <legend className={styles.legend}>Search</legend>
      <div className={styles.searchIconContainer} onClick={handleOnFocus}>
        <SearchIcon />
      </div>
      <button className={styles.input}>
        {width <= 992 ? localeResources.search.searchItems : localeResources.search.brandOrProductOrProduct}
      </button>
    </fieldset>
  );
};
